import { sqrt } from "../math.js";
var sqrt3 = sqrt(3);
export default {
    draw: function (context, size) {
        var s = sqrt(size) * 0.6824;
        var t = s / 2;
        var u = (s * sqrt3) / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
